import React, { FC } from 'react';
import { Col, Row, Tabs, Typography } from 'antd';

import EnvironmentSelect from '@lib/components/env-select';

import ClanWar from './components/clan-war';
import { useGetCurrentProgressContext } from './components/context';
import Gauntlet from './components/gauntlet';
import Lobby from './components/lobby';

const { Text } = Typography;

const GetCurrentProgressPageBody: FC = () => {
  const { environment, setEnvironment } = useGetCurrentProgressContext();

  return (
    <div className="flex flex-col flex-1 max-h-full min-h-full p-4">
      <Row gutter={16} className="mb-4">
        <Col>
          <Text className="mr-2">Environment</Text>
          <EnvironmentSelect value={environment} style={{ width: 200 }} onChange={setEnvironment} />
        </Col>
      </Row>
      <Tabs size="small" defaultActiveKey="lobby">
        <Tabs.TabPane key="lobby" tab="Normal Lobby">
          <Lobby />
        </Tabs.TabPane>
        <Tabs.TabPane key="clanWar" tab="Clan war">
          <ClanWar />
        </Tabs.TabPane>
        <Tabs.TabPane key="gauntlet" tab="Gauntlet">
          <Gauntlet />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default GetCurrentProgressPageBody;
